import { render, staticRenderFns } from "./SiteSearchResult.vue?vue&type=template&id=2decb002&"
import script from "./SiteSearchResult.vue?vue&type=script&lang=ts&"
export * from "./SiteSearchResult.vue?vue&type=script&lang=ts&"
import style0 from "./SiteSearchResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleLink: require('/tmp/build_453bf6d7/src/components/misc/ArticleLink.vue').default})
